<template>
  <ev-template-vehicle-panel />
</template>

<script>
import EvTemplateVehiclePanel from "../components/config/EvTemplateVehiclePanel";

export default {
  components: { EvTemplateVehiclePanel }
};
</script>
